// extracted by mini-css-extract-plugin
export default {"link":"HeadPage_link__Amr5o","lastLink":"HeadPage_lastLink__1I+qs"};